import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom'; // Essential Router imports
import { Phone, Menu, X } from 'lucide-react'; // Icon imports
import './About.css';
import './Home.css'; // Import shared CSS for Header and Footer styles

// --- Shared Header Data ---
const navItems = [
    { id: 'home', label: 'Home', path: '/' }, 
    { id: 'about', label: 'About', path: '/about' },
    { id: 'services', label: 'Services', path: '/services' },
    { id: 'projects', label: 'Projects', path: '/projects' },
    { id: 'contact', label: 'Contact', path: '/contact' }
];

// Helper Component for Header content (to keep main About component cleaner)
const HeaderContent = ({ isMobileMenuOpen, setIsMobileMenuOpen }) => {
    const location = useLocation();
    const getLinkClass = (path) => location.pathname === path ? 'active' : '';

    // NOTE: This Header is simplified and doesn't include the scroll-based 'scrolled' class, 
    // as that logic primarily belonged to the Home page and would require useEffect here.

    return (
        <header className="header">
            <div className="header-content">
                <img src="/assets/Construction Logo (4).png" alt="S&L Construction Logo" className="header-logo" />
                <Link to="/" className="logo">
                    S&L Construction, Inc.
                </Link>

                <nav className="nav-desktop">
                    {navItems.map(item => (
                        <Link 
                            key={item.id}
                            to={item.path} 
                            className={`nav-link ${getLinkClass(item.path)}`}
                        >
                            {item.label}
                        </Link>
                    ))}
                </nav>

                <a href="tel:8884642289" className="header-phone">
                    <Phone size={18} />
                    (312) 607-7476
                </a>

                <button
                    className="mobile-menu-button"
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                >
                    {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            <div className={`nav-mobile ${isMobileMenuOpen ? 'open' : ''}`}>
                {navItems.map(item => (
                    <Link 
                        key={item.id}
                        to={item.path}
                        className={`nav-link-mobile ${getLinkClass(item.path)}`}
                        onClick={() => setIsMobileMenuOpen(false)} 
                    >
                        {item.label}
                    </Link>
                ))}
                <a href="tel:8884642289" className="nav-phone-mobile">
                    <Phone size={18} />
                    (888) 464-2289
                </a>
            </div>
        </header>
    );
};
// --- End Shared Header Content ---

const About = () => {
    const isVisible = true; 
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // State to control mobile menu

    return (
        <div className="page-wrapper">
            {/* 1. HEADER SECTION (Shared) */}
            <HeaderContent 
                isMobileMenuOpen={isMobileMenuOpen} 
                setIsMobileMenuOpen={setIsMobileMenuOpen} 
            />

            {/* 2. MAIN CONTENT (About Page Specific) */}
            <main>
                <div className="about-container">
                    <div className="about-content">
                        <div className={`about-header ${isVisible ? 'animate-in' : ''}`}>
                            <span className="section-label">Who We Are</span>
                            <h2 className="about-title">Building Dreams, One Space at a Time</h2>
                        </div>
                        
                        <div className={`about-card ${isVisible ? 'slide-in' : ''}`}>
                            <div className="card-glow"></div>
                            <p className="about-text">
                                At S&L Construction, Inc., we believe every home tells a story — your story. 
                                With decades of expertise in remodeling and custom building, we transform ideas 
                                into living spaces that are both functional and timeless. From the first sketch 
                                to the final detail, our focus is on craftsmanship, precision, and personalization.
                            </p>
                        </div>

                        <div className={`stats-grid ${isVisible ? 'fade-in-up' : ''}`}>
                            <div className="stat-item">
                                <div className="stat-number">100%</div>
                                <div className="stat-label">Focus on Precision & Execution</div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-number">100%</div>
                                <div className="stat-label">Focus on Timeliness & Trust</div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-number">100%</div>
                                <div className="stat-label">Client Satisfaction</div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            
            {/* 3. FOOTER SECTION (Shared) */}
            <footer className="footer-section">
                <div className="footer-content">
                    <p className="footer-copy">© 2025 S&L Construction, Inc. | All Rights Reserved</p>
                    <a href="tel:8884642289" className="footer-phone">
                        <Phone size={16} />
                        Call Us: (312) 607-7476
                    </a>
                </div>
            </footer>
        </div>
    );
};

export default About;